<mat-divider />

<!-- Search result -->
@if (searchResult && (searchResult.length + searchResultLagrangePoints.length) > 0) {
  <mat-accordion multi>
    <mat-expansion-panel expanded class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ (searchResult.length + searchResultLagrangePoints.length) | i18nPlural: { '=1': 'NB result', 'other': 'NB results' } | translate: { NB: (searchResult.length + searchResultLagrangePoints.length) } }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-grid-list [cols]="nbCol" gutterSize="10px" rowHeight="50px">
        @for (body of searchResult; track body) {
          <mat-grid-tile [class]="'celestial-body ' + body.type" (click)="onBodySelected(body)">
            @if (HAS_SYMBOL.includes(body)) {
              <img [ngSrc]="'assets/symbols/' + body.id + '.svg'" width="25" height="25" [alt]="body.id | translate">
            }
            <span class="name">{{ body.id | translate }}</span>
          </mat-grid-tile>
        }
        @for (type of searchResultLagrangePoints; track type) {
          <mat-grid-tile class="lagrange-point" (click)="onLagrangePointSelected(type)">
            <span class="name">{{ 'Sun–Earth ' + type | translate }}</span>
          </mat-grid-tile>
        }
      </mat-grid-list>
    </mat-expansion-panel>
  </mat-accordion>
}

<!-- No search result -->
@if (searchResult && (searchResult.length + searchResultLagrangePoints.length) === 0) {
  <div class="empty-search">
    <img ngSrc="assets/empty_search.svg" width="150" height="160" [alt]="'No results' | translate">
    <h2>{{ 'No results' | translate }}</h2>
    <h4>
      {{ 'Try' | translate }}
      <a routerLink="" (click)="onBodySelected(JUPITER)">{{ JUPITER.id | translate }}</a>{{ ', ' | translate }}
      <a routerLink="" (click)="onBodySelected(MOON)">{{ 'the Moon' | translate }}</a>{{ ' or ' | translate }}
      <a routerLink="" (click)="onBodySelected(GANYMEDE)">{{ GANYMEDE.id | translate }}</a>
    </h4>
  </div>
}

<!-- Empty search -->
@if (!searchResult) {
  <mat-accordion multi>
    <!-- Sun + inner planets -->
    <mat-expansion-panel expanded class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ SUN.id | translate }}</mat-panel-title>
        <mat-panel-description>
          {{ 'NB planets' | translate:{ NB: SUN.satellites.length } }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-grid-list [cols]="nbCol" gutterSize="10px" rowHeight="50px">
        <mat-grid-tile [class]="SUN.type" (click)="onBodySelected(SUN)">
          @if (HAS_SYMBOL.includes(SUN)) {
            <img [ngSrc]="'assets/symbols/' + SUN.id + '.svg'" width="25" height="25" [alt]="SUN.id | translate">
          }
          <span class="name">{{ SUN.id | translate }}</span>
        </mat-grid-tile>
      </mat-grid-list>
      @for (planet of INNER_PLANETS; track planet) {
        <mat-grid-list [cols]="nbCol" gutterSize="10px" rowHeight="50px">
          <mat-grid-tile [class]="planet.type" (click)="onBodySelected(planet)">
            @if (HAS_SYMBOL.includes(planet)) {
              <img [ngSrc]="'assets/symbols/' + planet.id + '.svg'" width="25" height="25" [alt]="planet.id | translate">
            }
            <span class="name">{{ planet.id | translate }}</span>
          </mat-grid-tile>
          @for (moon of planet.satellites; track moon) {
            <mat-grid-tile [class]="moon.type" (click)="onBodySelected(moon)">
              @if (HAS_SYMBOL.includes(moon)) {
                <img [ngSrc]="'assets/symbols/' + moon.id + '.svg'" width="25" height="25" [alt]="moon.id | translate">
              }
              <span class="name">{{ moon.id | translate }}</span>
            </mat-grid-tile>
          }
        </mat-grid-list>
      }
    </mat-expansion-panel>
    <!-- Outer planets -->
    @for (planet of OUTER_PLANETS; track planet) {
      <mat-expansion-panel class="mat-elevation-z0">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ planet.id | translate }}</mat-panel-title>
          @if (planet.satellites.length) {
            <mat-panel-description>
              {{ planet.satellites.length | i18nPlural: { '=1': 'NB satellite', 'other': 'NB satellites' } | translate: { NB: planet.satellites.length } }}
            </mat-panel-description>
          }
        </mat-expansion-panel-header>
        <mat-grid-list [cols]="nbCol" gutterSize="10px" rowHeight="50px">
          <mat-grid-tile [class]="planet.type" (click)="onBodySelected(planet)">
            @if (HAS_SYMBOL.includes(planet)) {
              <img [ngSrc]="'assets/symbols/' + planet.id + '.svg'" width="25" height="25" [alt]="planet.id | translate">
            }
            <span class="name">{{ planet.id | translate }}</span>
          </mat-grid-tile>
          @for (moon of planet.satellites; track moon) {
            <mat-grid-tile [class]="moon.type" (click)="onBodySelected(moon)">
              @if (HAS_SYMBOL.includes(moon)) {
                <img [ngSrc]="'assets/symbols/' + moon.id + '.svg'" width="25" height="25" [alt]="moon.id | translate">
              }
              <span class="name">{{ moon.id | translate }}</span>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </mat-expansion-panel>
    }
    <!-- Dwarf planets -->
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Dwarf planets' | translate }}</mat-panel-title>
        <mat-panel-description>
          {{ 'NB1 dwarf planets and NB2 satellites' | translate:{ NB1: DWARF_PLANETS.length, NB2: NB_DWARF_PLANETS_SATELLITES } }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      @for (planet of DWARF_PLANETS; track planet) {
        <mat-grid-list [cols]="nbCol" gutterSize="10px" rowHeight="50px">
          <!-- The dwarf planet -->
          <mat-grid-tile [class]="planet.type" (click)="onBodySelected(planet)">
            @if (HAS_SYMBOL.includes(planet)) {
              <img [ngSrc]="'assets/symbols/' + planet.id + '.svg'" width="25" height="25" [alt]="planet.id | translate">
            }
            <span class="name">{{ planet.id | translate }}</span>
          </mat-grid-tile>
          <!-- The dwarf planet moon's -->
          @for (moon of planet.satellites; track moon) {
            <mat-grid-tile [class]="moon.type" (click)="onBodySelected(moon)">
              @if (HAS_SYMBOL.includes(moon)) {
                <img [ngSrc]="'assets/symbols/' + moon.id + '.svg'" width="25" height="25" [alt]="moon.id | translate">
              }
              <span class="name">{{ moon.id | translate }}</span>
            </mat-grid-tile>
          }
        </mat-grid-list>
      }
    </mat-expansion-panel>
    <!-- Lagrange points -->
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Lagrange points' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <mat-grid-list [cols]="nbCol" gutterSize="10px" rowHeight="50px" class="lagrange-points-grid">
        @for (type of LAGRANGE_POINT_TYPES; track type) {
          <mat-grid-tile (click)="onLagrangePointSelected(type)" class="lagrange-point">
            <span class="name">{{ 'Sun–Earth ' + type | translate }}</span>
          </mat-grid-tile>
        }
      </mat-grid-list>
    </mat-expansion-panel>
  </mat-accordion>
}
